<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TBnQxa/tc-custom/9781459292710.jpg?1724929954830" alt="This image is the cover for the book Secrets of a Billionaire's Mistress, One Night With Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secrets of a Billionaire's Mistress, One Night With Consequences
      </h1>
      <p class="bookDescription body article font2">
        <b>A passionate night with an Italian billionaire transforms the life of an English waitress in this romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Waitress . . . <br/><br/>Neither tall, willowy nor sophisticated, waitress Darcy Denton knew she wasn’t Renzo Sabatini’s usual type. But enthralled by the powerful magnate, unworldly Darcy became addicted to their passionate nights together.<br/><br/>Mistress . . . <br/><br/>Ensconced in Renzo’s secluded Tuscan villa, Darcy glimpses Renzo’s troubled past and desolate soul. She should end it before she gets in too deep, but then she discovers she’s pregnant!<br/><br/>Wife?<br/><br/>Harboring her own childhood secrets, Darcy dare not tell Renzo, but as the mother of his child it’s only a matter of time—nine months, to be exact—before he claims what’s his . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d8132998